import React, { memo, useEffect, useState } from 'react';
import mova from 'mova';
import PropTypes from 'prop-types';
import './PhoneInput.scss';
import InputGroup from '@components/layout/InputGroup/InputGroup';
import { withFormsy } from 'formsy-react';
import { default as PhoneInputLibrary } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { phone } from 'phone';
import axios from 'axios';
import LocalStorageService from '@services/LocalStorage.service';

const t = mova.ns('base');

function PhoneInput({ setValue, errorMessage, isPristine, fetchCountry }) {
  const errorPresent = !isPristine && Boolean(errorMessage);
  const filledCountry = LocalStorageService.get(LocalStorageService.Keys.COUNTRY);
  const [country, setCountry] = useState(filledCountry || 'ua');

  useEffect(() => {
    // Get user's country code based on IP address
    if (fetchCountry) {
      axios.get('https://ipapi.co/json/')
        .then(response => {
          if (response.data?.country_code) {
            setCountry(response.data.country_code.toLowerCase());
            LocalStorageService.set(LocalStorageService.Keys.COUNTRY, response.data.country_code.toLowerCase());
          }
        });
    }
  }, [fetchCountry]);

  const phoneChanged = (newValue, country) => {
    if (!newValue) return;
    const formattedPhone = phone(newValue, { country: country?.countryCode });
    if (formattedPhone.isValid) {
      setValue(formattedPhone.phoneNumber);
    } else {
      setValue(newValue);
    }
  };
  return (
    <InputGroup
      error={errorMessage}
      errorPresent={errorPresent}
    >
      <PhoneInputLibrary
        containerClass={`react-tel-input`}
        dropdownClass={`react-tel-input`}
        searchClass={`react-tel-input`}
        preferredCountries={['es', 'fi', 'ua']}
        country={country}
        searchPlaceholder={t('submitFilterForm')}
        enableSearch={true}
        onChange={phoneChanged}
      />
    </InputGroup>
  );
}

PhoneInput.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  fullWidth: PropTypes.bool,
  fontSize: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  isPristine: PropTypes.bool.isRequired,
  fetchCountry: PropTypes.bool,
};

PhoneInput.defaultProps = {
  label: undefined,
  defaultValue: undefined,
  fullWidth: false,
  fontSize: 16,
  onChange: undefined,
  errorMessage: null,
  value: '',
  fetchCountry: false,
};

export default memo(withFormsy(PhoneInput));
